// extracted by mini-css-extract-plugin
module.exports = {"blocks2":"blocks2_blocks2__4G8Vb","blocks2-row":"blocks2_blocks2-row__F6KRh","blocks2-left":"blocks2_blocks2-left__S858d","blocks2-right":"blocks2_blocks2-right__dcuVE"};